import axios from 'axios';

// Falls back to same-origin ("/api") when REACT_APP_BACKEND_URL is not set at
// build time. This prevents the URL from becoming "undefined/api/..." and works
// when the frontend and backend are served from the same domain (e.g. via Nginx).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gnc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const publicApi = {
  getSettings: () => api.get('/settings').then((r) => r.data),
  getCruises: (params = {}) => api.get('/cruises', { params }).then((r) => r.data),
  getCruise: (slug) => api.get(`/cruises/${slug}`).then((r) => r.data),
  getPackages: (params = {}) => api.get('/packages', { params }).then((r) => r.data),
  getPackage: (slug) => api.get(`/packages/${slug}`).then((r) => r.data),
  getTours: () => api.get('/tour-categories').then((r) => r.data),
  getBlog: () => api.get('/blog').then((r) => r.data),
  getBlogPost: (slug) => api.get(`/blog/${slug}`).then((r) => r.data),
  getFaqs: () => api.get('/faqs').then((r) => r.data),
  createLead: (payload) => api.post('/leads', payload).then((r) => r.data),
};

export const adminApi = {
  login: (username, password) => {
    const form = new URLSearchParams();
    form.append('username', username);
    form.append('password', password);
    return api.post('/admin/login', form, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((r) => r.data);
  },
  me: () => api.get('/admin/me').then((r) => r.data),
  // cruises
  createCruise: (data) => api.post('/admin/cruises', data).then((r) => r.data),
  updateCruise: (id, data) => api.patch(`/admin/cruises/${id}`, data).then((r) => r.data),
  deleteCruise: (id) => api.delete(`/admin/cruises/${id}`).then((r) => r.data),
  // packages
  createPackage: (data) => api.post('/admin/packages', data).then((r) => r.data),
  updatePackage: (id, data) => api.patch(`/admin/packages/${id}`, data).then((r) => r.data),
  deletePackage: (id) => api.delete(`/admin/packages/${id}`).then((r) => r.data),
  // tours
  createTour: (data) => api.post('/admin/tour-categories', data).then((r) => r.data),
  updateTour: (id, data) => api.patch(`/admin/tour-categories/${id}`, data).then((r) => r.data),
  deleteTour: (id) => api.delete(`/admin/tour-categories/${id}`).then((r) => r.data),
  // blog
  listBlog: () => api.get('/admin/blog').then((r) => r.data),
  createBlog: (data) => api.post('/admin/blog', data).then((r) => r.data),
  updateBlog: (id, data) => api.patch(`/admin/blog/${id}`, data).then((r) => r.data),
  deleteBlog: (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data),
  // faqs
  createFaq: (data) => api.post('/admin/faqs', data).then((r) => r.data),
  updateFaq: (id, data) => api.patch(`/admin/faqs/${id}`, data).then((r) => r.data),
  deleteFaq: (id) => api.delete(`/admin/faqs/${id}`).then((r) => r.data),
  // leads
  listLeads: (params = {}) => api.get('/admin/leads', { params }).then((r) => r.data),
  updateLead: (id, data) => api.patch(`/admin/leads/${id}`, data).then((r) => r.data),
  deleteLead: (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data),
  // settings
  updateSettings: (data) => api.patch('/admin/settings', data).then((r) => r.data),
};
